import { clientLogger } from '@/lib/clientLogger';
import imageCompression from 'browser-image-compression';

export async function compressImage(file: File): Promise<{
  blob: Blob;
  mimeType: string;
  sizeBytes: number;
}> {
  if (file.type === 'application/pdf') {
    // Skip compression for PDFs; handled with attachment size validation elsewhere
    return {
      blob: file,
      mimeType: 'application/pdf',
      sizeBytes: file.size
    };
  }

  if (!file.type.startsWith('image/')) {
    throw new Error('File must be an image');
  }

  const options = {
    maxSizeMB: 0.24, // 240KB target
    maxWidthOrHeight: 1920,
    useWebWorker: true,
    initialQuality: 0.8,
    alwaysKeepResolution: true,
    onProgress: (progress: number) => {
      clientLogger.info('Compression progress:', progress);
    }
  };

  let quality = 0.8;
  let compressedBlob = await imageCompression(file, options);

  // Progressive compression if still too large
  while (compressedBlob.size > 240 * 1024 && quality > 0.1) {
    quality -= 0.1;
    options.initialQuality = quality;
    compressedBlob = await imageCompression(file, options);
  }

  if (compressedBlob.size > 250 * 1024) {
    throw new Error('Image could not be compressed to under 250KB');
  }

  return {
    blob: compressedBlob,
    mimeType: 'image/jpeg',
    sizeBytes: compressedBlob.size
  };
}
